(() => {
  const TARGET = 'walk-explore-set';
  const PRODUCT = {
    tracker: 'smart-pet-tracker-collar-dual-system-tracking-no-monthly-fee',
    harness: 'soft-no-pull-cat-harness-leash-set-comfortable-adjustable-walking-vest-for-cats-small-dogs',
    bottle: 'portable-dog-water-bottle-with-food-storage-2-in-1-travel-bottle-for-dogs-cats',
    addon: '3m-retractable-pet-leash'
  };
  const TRACKER_VISUALS = {
    black: { image: 'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/ChatGPT_Image_2026_9_3_22_18_28.png?v=1788448470', swatch: '#191919' },
    pink: { image: 'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/ChatGPT_Image_2026_9_3_22_46_45.png?v=1788448470', swatch: '#efb5c4' }
  };
  const BOTTLE_VISUALS = {
    white: { image: 'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/ChatGPTImage2026_8_28_22_04_49.png?v=1788072762', swatch: '#f4f3ee' },
    yellow: { image: 'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/ChatGPTImage2026_8_28_22_03_40.png?v=1788072762', swatch: '#e7bd35' },
    purple: { image: 'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/759d8749-dab5-4c6b-a3f9-1ae953304c16.png?v=1788072762', swatch: '#8d72b6' }
  };
  const TRACKER_GROUPS = {
    black: [
      'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/ChatGPT_Image_2026_9_3_22_18_28.png?v=1788448470',
      'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/2cf8b1c5-416b-46a2-833c-7ecdf44b8e46.png?v=1788667847',
      'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/18903a66-9771-49e4-8545-8887ca53e47d.png?v=1788630461',
      'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/97b1eb69-4a5f-49d5-b839-6d29f4edf461.png?v=1788630460',
      'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/fbf76740-2348-43b7-93b8-9003c2b928ad.png?v=1788630460',
      'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/0766c2e6-1a77-466d-b541-8f0856e82371.png?v=1788667899'
    ],
    pink: [
      'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/ChatGPT_Image_2026_9_3_22_46_45.png?v=1788448470',
      'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/1e513d35-5613-43ac-9593-e265ea78da8f.png?v=1788664065',
      'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/a4c8b32f-ea63-4afc-a3a4-153ef600088a.png?v=1788664072',
      'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/1f0713e4-2313-406c-8c50-69c76271db4a.png?v=1788664072',
      'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/ac2c08c6-7240-4355-96b9-c75d72a2fa88.png?v=1788668126',
      'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/1d9a543d-c0a6-4bf2-9734-1314e85ca21d.png?v=1788664071'
    ]
  };

  const cache = new Map();
  const norm = value => String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  const handle = () => {
    const m = location.pathname.match(/\/products\/([^/?#]+)/i);
    return m ? decodeURIComponent(m[1]).toLowerCase() : '';
  };
  const legend = group => (group?.querySelector('legend')?.textContent || '').split(':')[0].trim();
  const findGroup = (root, names) => [...root.querySelectorAll('.pl-option[data-option-position], [data-option-position]')]
    .find(group => names.some(name => norm(legend(group)) === norm(name)));
  const selected = group => group?.querySelector('[data-option-value].is-selected')?.dataset.optionValue || '';
  const splitPair = value => {
    const parts = String(value || '').split(/\s+\+\s+/).map(x => x.trim()).filter(Boolean);
    return parts.length >= 2 ? [parts[0], parts.slice(1).join(' + ')] : ['', ''];
  };
  const unique = values => [...new Set(values.filter(Boolean))];
  const fetchProduct = productHandle => {
    if (!cache.has(productHandle)) {
      cache.set(productHandle, fetch(`/products/${productHandle}.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      }).then(r => {
        if (!r.ok) throw new Error(`Unable to load ${productHandle}`);
        return r.json();
      }));
    }
    return cache.get(productHandle);
  };
  const optionName = option => typeof option === 'string' ? option : option?.name || '';
  const optionIndex = (product, matcher) => {
    const i = (product?.options || []).findIndex(option => matcher.test(optionName(option)));
    return i >= 0 ? i : 0;
  };
  const imageSrc = image => typeof image === 'string' ? image : image?.src || image?.url || '';
  const imageKey = src => {
    try { return new URL(src, location.origin).pathname.replace(/_(?:pico|icon|thumb|small|compact|medium|large|grande|original|master|\d+x\d*|x\d+)(?=\.[a-z0-9]+$)/i, ''); }
    catch (_) { return String(src || '').split('?')[0]; }
  };
  const valueMatch = (a, b) => {
    const x = norm(a), y = norm(b);
    return !y || x === y || x.startsWith(y) || y.startsWith(x);
  };
  const findVariant = (product, values) => {
    const variants = product?.variants || [];
    return variants.find(v => values.every((value, i) => valueMatch(v.options?.[i], value)) && v.available)
      || variants.find(v => values.every((value, i) => valueMatch(v.options?.[i], value)))
      || variants.find(v => v.available)
      || variants[0]
      || null;
  };
  const colorVariant = (product, color) => {
    const i = optionIndex(product, /colou?r/i);
    const variants = product?.variants || [];
    return variants.find(v => norm(v.options?.[i]) === norm(color) && v.available)
      || variants.find(v => norm(v.options?.[i]) === norm(color))
      || variants.find(v => v.available)
      || variants[0]
      || null;
  };
  const variantImage = variant => imageSrc(variant?.featured_image);
  const money = cents => {
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(Number(cents || 0) / 100); }
    catch (_) { return `$${(Number(cents || 0) / 100).toFixed(2)}`; }
  };

  const ensureStyles = () => {
    if (document.getElementById('walk-explore-upgrade-styles')) return;
    const style = document.createElement('style');
    style.id = 'walk-explore-upgrade-styles';
    style.textContent = `
      [data-walk-hidden-combo="true"]{display:none!important}
      .pl-gallery.pl-gallery--walk-scattered{display:block!important}
      .pl-gallery.pl-gallery--walk-scattered>.pl-gallery__thumbs,.pl-gallery.pl-gallery--walk-scattered>.pl-gallery__stage{display:none!important}
      .pl-gallery__stack{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:14px;width:100%}
      .pl-gallery__item{position:relative;aspect-ratio:1/1;margin:0;overflow:hidden;background:#f6f6f2}
      .pl-gallery__stack-image{display:block;width:100%;height:100%;object-fit:contain;object-position:center}
      .pl-gallery__item .pl-gallery__badge{position:absolute;left:18px;top:18px}
      .pl-mix-intro{margin:0 0 16px;padding:12px 14px;border:1px solid #e1e3df;border-radius:12px;background:#fafaf7}
      .pl-mix-intro strong{display:block;font-size:13px;color:#24282b;margin-bottom:2px}.pl-mix-intro span{font-size:11px;color:#697174;line-height:1.4}
      .pl-mix-item{display:inline-flex;align-items:center;gap:10px;width:auto;max-width:100%;margin:0 0 8px;padding:6px 9px;border:1px solid #dde0dc;border-radius:999px;background:#fff}
      .pl-mix-item__copy strong{font-size:11px;line-height:1.2;color:#24282b}.pl-mix-item__copy small{display:none}
      .pl-mix-item__toggle{display:inline-flex;align-items:center;gap:5px;font-size:10px;font-weight:700;cursor:pointer;white-space:nowrap}.pl-mix-item__toggle input{width:14px;height:14px;margin:0;accent-color:#24282b}
      .pl-mix-group-off{opacity:.38;filter:grayscale(.35)}.pl-mix-group-off .pl-option__values{pointer-events:none}
      .pl-mix-status{margin:-8px 0 16px;color:#747b7d;font-size:10px;line-height:1.4}
      @media(max-width:749px){.pl-gallery__stack{grid-template-columns:1fr;gap:12px}.pl-gallery__item .pl-gallery__badge{left:14px;top:14px}.pl-mix-item{padding:6px 8px;gap:8px}}
    `;
    document.head.appendChild(style);
  };

  const makeVirtualGroup = (label, values, current, choose, visuals) => {
    const group = document.createElement('fieldset');
    group.className = 'pl-option';
    group.dataset.walkVirtual = label;
    const lg = document.createElement('legend');
    lg.append(document.createTextNode(`${label}: `));
    const strong = document.createElement('strong');
    strong.dataset.optionLabel = '';
    strong.textContent = current;
    lg.appendChild(strong);
    const wrap = document.createElement('div');
    wrap.className = 'pl-option__values';

    values.forEach(value => {
      const visual = visuals[norm(value)] || {};
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `pl-option__button is-swatch${norm(value) === norm(current) ? ' is-selected' : ''}`;
      button.dataset.walkValue = value;
      button.setAttribute('aria-pressed', norm(value) === norm(current) ? 'true' : 'false');
      button.setAttribute('aria-label', `${label}: ${value}`);
      button.title = value;
      const swatch = document.createElement('span');
      swatch.className = 'pl-swatch';
      swatch.style.background = visual.swatch || '#d9dcda';
      swatch.style.setProperty('--pl-swatch-color', visual.swatch || '#d9dcda');
      if (visual.image) {
        const img = document.createElement('img');
        img.className = 'pl-swatch__image';
        img.src = visual.image;
        img.alt = value;
        img.loading = 'lazy';
        swatch.appendChild(img);
      }
      const tone = document.createElement('span');
      tone.className = 'pl-swatch__tone';
      tone.style.background = visual.swatch || '#d9dcda';
      tone.setAttribute('aria-hidden', 'true');
      swatch.appendChild(tone);
      const hidden = document.createElement('span');
      hidden.className = 'visually-hidden';
      hidden.textContent = value;
      button.append(swatch, hidden);
      button.addEventListener('click', () => choose(value));
      wrap.appendChild(button);
    });
    group.append(lg, wrap);
    return group;
  };
  const updateVirtual = (group, value) => {
    group.querySelector('[data-option-label]').textContent = value;
    group.querySelectorAll('[data-walk-value]').forEach(button => {
      const active = norm(button.dataset.walkValue) === norm(value);
      button.classList.toggle('is-selected', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };

  const init = root => {
    if (!root || handle() !== TARGET || root.dataset.walkExploreSplitReady === 'true') return;
    ensureStyles();

    const combo = findGroup(root, ['Tracker + Bottle Color']);
    const harness = findGroup(root, ['Harness & Leash Color']);
    const size = findGroup(root, ['Compatibility & Size']);
    if (!combo || !harness || !size) return;

    const parsed = [...combo.querySelectorAll('[data-option-value]')].map(button => ({
      button,
      pair: splitPair(button.dataset.optionValue)
    })).filter(item => item.pair[0] && item.pair[1]);
    if (!parsed.length) return;

    const trackerValues = unique(parsed.map(item => item.pair[0]));
    const bottleValues = unique(parsed.map(item => item.pair[1]));
    let [trackerValue, bottleValue] = splitPair(selected(combo));
    trackerValue ||= trackerValues[0] || '';
    bottleValue ||= bottleValues[0] || '';

    combo.dataset.walkHiddenCombo = 'true';
    let trackerGroup, bottleGroup;
    const choosePair = (tracker, bottle) => {
      const target = parsed.find(item => norm(item.pair[0]) === norm(tracker) && norm(item.pair[1]) === norm(bottle));
      if (!target) return;
      trackerValue = tracker;
      bottleValue = bottle;
      updateVirtual(trackerGroup, trackerValue);
      updateVirtual(bottleGroup, bottleValue);
      if (!target.button.classList.contains('is-selected')) target.button.click();
    };

    trackerGroup = makeVirtualGroup('Tracker Color', trackerValues, trackerValue, value => choosePair(value, bottleValue), TRACKER_VISUALS);
    bottleGroup = makeVirtualGroup('Bottle Color', bottleValues, bottleValue, value => choosePair(trackerValue, value), BOTTLE_VISUALS);
    const parent = combo.parentElement;
    parent.insertBefore(trackerGroup, combo);
    parent.insertBefore(bottleGroup, combo);
    parent.insertBefore(harness, size);

    const syncPair = () => {
      const pair = splitPair(selected(combo));
      if (!pair[0] || !pair[1]) return;
      trackerValue = pair[0];
      bottleValue = pair[1];
      updateVirtual(trackerGroup, trackerValue);
      updateVirtual(bottleGroup, bottleValue);
    };
    combo.addEventListener('click', () => setTimeout(syncPair, 0), true);
    root.querySelector('[data-variant-select]')?.addEventListener('change', () => setTimeout(syncPair, 0));
    root.dataset.walkExploreSplitReady = 'true';

    initUpgrade(root, { trackerGroup, bottleGroup, harnessGroup: harness, sizeGroup: size });
  };

  const initUpgrade = async (root, groups) => {
    if (root.dataset.walkExploreUpgradeReady === 'true') return;
    root.dataset.walkExploreUpgradeReady = 'true';

    const form = root.querySelector('form.pl-buy__form');
    const add = root.querySelector('[data-add-to-cart]');
    const price = root.querySelector('[data-product-price]');
    const options = root.querySelector('.pl-options');
    if (!form || !add || !price || !options) return;

    const components = [
      { key: 'tracker', label: 'Tracker Collar', handle: PRODUCT.tracker, groups: [groups.trackerGroup] },
      { key: 'bottle', label: 'Bottle', handle: PRODUCT.bottle, groups: [groups.bottleGroup] },
      { key: 'harness', label: 'Harness & Leash', handle: PRODUCT.harness, groups: [groups.harnessGroup, groups.sizeGroup] }
    ];
    const intro = document.createElement('div');
    intro.className = 'pl-mix-intro';
    intro.innerHTML = '<strong>Build your set your way</strong><span>Select any one item, two items, or the full set. Only selected items will be added to cart.</span>';
    options.before(intro);
    const status = document.createElement('p');
    status.className = 'pl-mix-status';
    add.before(status);

    components.forEach(item => {
      const row = document.createElement('div');
      row.className = 'pl-mix-item';
      row.dataset.mixComponent = item.key;
      row.innerHTML = `<div class="pl-mix-item__copy"><strong>${item.label}</strong><small>Optional</small></div><label class="pl-mix-item__toggle"><input type="checkbox" checked><span>Include</span></label>`;
      item.groups[0].before(row);
      item.toggle = row.querySelector('input');
    });

    const getAddonInput = () => {
      const node = root.querySelector('[data-addon-choice]');
      return node?.matches?.('input[type="checkbox"],input[type="radio"]')
        ? node
        : node?.querySelector?.('input[type="checkbox"],input[type="radio"]')
          || root.querySelector('[data-retractable-addon] input[type="checkbox"],[data-retractable-addon] input[type="radio"]')
          || null;
    };

    let addonProduct = null;
    await Promise.all([
      ...components.map(item => fetchProduct(item.handle).then(product => { item.product = product; })),
      fetchProduct(PRODUCT.addon).then(product => { addonProduct = product; }).catch(() => null)
    ]);

    const currentValue = group => group.dataset.walkVirtual
      ? group.querySelector('[data-walk-value].is-selected')?.dataset.walkValue || ''
      : selected(group);
    const refresh = () => {
      let total = 0, count = 0, unavailable = false;
      components.forEach(item => {
        const included = item.toggle.checked;
        item.groups.forEach(group => group.classList.toggle('pl-mix-group-off', !included));
        if (!included) { item.variant = null; return; }
        count += 1;
        const values = item.groups.map(currentValue).filter(Boolean);
        item.variant = findVariant(item.product, values);
        if (!item.variant?.available) unavailable = true;
        else total += Number(item.variant.price || 0);
      });
      const addonInput = getAddonInput();
      if (addonInput?.checked) {
        const v = addonProduct?.variants?.find(x => x.available) || addonProduct?.variants?.[0];
        if (!v?.available) unavailable = true;
        else total += Number(v.price || 0);
      }
      price.textContent = money(total);
      add.disabled = count === 0 || unavailable;
      const label = add.querySelector('span');
      if (label) label.textContent = count === 0 ? 'Choose at least one item' : unavailable ? 'Selected option sold out' : 'Add selected items';
      status.textContent = count === 0 ? 'Choose at least one item.' : `${count} item${count === 1 ? '' : 's'} selected${addonInput?.checked ? ' + add-on' : ''}.`;
    };
    components.forEach(item => item.toggle.addEventListener('change', refresh));
    root.addEventListener('click', event => {
      if (event.target.closest('[data-option-value],[data-walk-value]')) setTimeout(refresh, 0);
    }, true);
    root.querySelector('[data-variant-select]')?.addEventListener('change', () => setTimeout(refresh, 0));
    root.addEventListener('change', event => {
      if (event.target.closest?.('[data-addon-choice],[data-retractable-addon]')) setTimeout(refresh, 0);
    });

    form.addEventListener('submit', async event => {
      event.preventDefault();
      event.stopImmediatePropagation();
      refresh();
      if (!components.some(item => item.toggle.checked)) return;
      const items = components.filter(item => item.toggle.checked && item.variant?.available)
        .map(item => ({ id: Number(item.variant.id), quantity: 1 }));
      const addonInput = getAddonInput();
      if (addonInput?.checked) {
        const v = addonProduct?.variants?.find(x => x.available) || addonProduct?.variants?.[0];
        if (v?.available) items.push({ id: Number(v.id), quantity: 1 });
      }
      if (!items.length) return;
      const label = add.querySelector('span');
      const old = label?.textContent || 'Add selected items';
      add.disabled = true;
      if (label) label.textContent = 'Adding…';
      try {
        const rootPath = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${rootPath}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error('Cart add failed');
        location.assign(`${rootPath}cart`);
      } catch (_) {
        add.disabled = false;
        if (label) label.textContent = old;
        alert('We could not add the selected items right now. Please try again.');
      }
    }, true);

    initGallery(root, components);
    refresh();
  };

  const initGallery = (root, components) => {
    const gallery = root.querySelector('.pl-gallery');
    if (!gallery) return;
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    const fallback = thumbs.map(thumb => ({
      src: thumb.dataset.src || thumb.querySelector('img')?.src || '',
      alt: thumb.dataset.galleryAlt || ''
    })).filter(item => item.src);
    const badge = gallery.querySelector('.pl-gallery__badge')?.cloneNode(true);
    let stack = gallery.querySelector('.pl-gallery__stack');
    if (!stack) {
      stack = document.createElement('div');
      stack.className = 'pl-gallery__stack';
      gallery.insertBefore(stack, gallery.firstChild);
    }
    gallery.classList.add('pl-gallery--walk-scattered');

    const render = (urls, label) => {
      const seen = new Set();
      const list = [];
      (urls || []).forEach(item => {
        const entry = typeof item === 'string' ? { src: item, alt: '' } : item;
        const key = imageKey(entry.src);
        if (!entry.src || seen.has(key)) return;
        seen.add(key);
        list.push(entry);
      });
      if (!list.length) return;
      const frag = document.createDocumentFragment();
      list.forEach((item, i) => {
        const figure = document.createElement('figure');
        figure.className = 'pl-gallery__item';
        figure.dataset.galleryGroup = label || 'walk';
        const img = document.createElement('img');
        img.className = 'pl-gallery__stack-image';
        img.src = item.src;
        img.alt = item.alt || `${label || 'Walk & Explore'} - image ${i + 1}`;
        img.loading = i < 2 ? 'eager' : 'lazy';
        figure.appendChild(img);
        frag.appendChild(figure);
      });
      stack.replaceChildren(frag);
      if (badge && stack.firstElementChild) stack.firstElementChild.appendChild(badge.cloneNode(true));
    };

    const groupForProduct = (product, color) => {
      const hero = variantImage(colorVariant(product, color));
      const i = optionIndex(product, /colou?r/i);
      const colorHeroes = new Set();
      const seenColors = new Set();
      (product?.variants || []).forEach(v => {
        const c = norm(v.options?.[i]);
        if (!c || seenColors.has(c)) return;
        seenColors.add(c);
        const src = variantImage(v);
        if (src) colorHeroes.add(imageKey(src));
      });
      const shared = (product?.images || []).map(imageSrc).filter(Boolean).filter(src => !colorHeroes.has(imageKey(src)));
      return [hero, ...shared].filter(Boolean);
    };

    let active = 'tracker', token = 0;
    const currentColor = group => group.dataset.walkVirtual
      ? group.querySelector('[data-walk-value].is-selected')?.dataset.walkValue || ''
      : selected(group);
    const show = async key => {
      const item = components.find(x => x.key === key);
      if (!item) return;
      const color = currentColor(item.groups[0]);
      if (!color) { render(fallback, 'bundle'); return; }
      active = key;
      const myToken = ++token;
      try {
        const urls = key === 'tracker' && TRACKER_GROUPS[norm(color)]
          ? TRACKER_GROUPS[norm(color)]
          : groupForProduct(item.product, color);
        if (myToken === token) render(urls.length ? urls : fallback, `${key}:${color}`);
      } catch (_) {
        if (myToken === token) render(fallback, 'bundle');
      }
    };

    render(fallback, 'bundle');
    show('tracker');

    root.addEventListener('click', event => {
      const button = event.target.closest('[data-walk-value],[data-option-value]');
      if (!button || !root.contains(button)) return;
      const group = button.closest('.pl-option');
      if (group === components.find(x => x.key === 'tracker')?.groups[0]) setTimeout(() => show('tracker'), 30);
      else if (group === components.find(x => x.key === 'bottle')?.groups[0]) setTimeout(() => show('bottle'), 30);
      else if (group === components.find(x => x.key === 'harness')?.groups[0]) setTimeout(() => show('harness'), 30);
      else if (group === components.find(x => x.key === 'harness')?.groups[1] && active === 'harness') setTimeout(() => show('harness'), 30);
    }, true);

    root.addEventListener('change', event => {
      const checkbox = event.target.closest?.('[data-mix-component] input[type="checkbox"]');
      if (!checkbox) return;
      const row = checkbox.closest('[data-mix-component]');
      if (checkbox.checked) { show(row.dataset.mixComponent); return; }
      if (row.dataset.mixComponent !== active) return;
      const next = components.find(item => item.toggle.checked);
      if (next) show(next.key); else render(fallback, 'bundle');
    });
  };

  const boot = () => document.querySelectorAll('[data-powlife-product]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
